const defaultComments = () => ({
  items: [],
  loading: false,
  loaded: false,
  sending: false
});

const supportReducer = (
  state = {
    submitting: false,
    requests: {
      items: [],
      loading: false,
      loaded: false
    },
    comments: {},
    closingWorkItemId: null,
    reopeningWorkItemId: null
  },
  action
) => {
  switch (action.type) {
    case "SET_SUPPORT_SUBMITTING":
      return {
        ...state,
        submitting: action.payload.submitting
      };

    case "SET_SUPPORT_REQUESTS_LOADING":
      return {
        ...state,
        requests: {
          ...state.requests,
          loading: action.payload.loading
        }
      };

    case "SET_SUPPORT_REQUESTS":
      return {
        ...state,
        requests: {
          items: action.payload.items,
          loading: false,
          loaded: true
        }
      };

    case "SET_SUPPORT_COMMENTS_LOADING":
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.workItemId]: {
            ...(state.comments[action.payload.workItemId] || defaultComments()),
            loading: action.payload.loading
          }
        }
      };

    case "SET_SUPPORT_COMMENTS":
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.workItemId]: {
            items: action.payload.items,
            loading: false,
            loaded: true,
            sending: false
          }
        }
      };

    case "SET_SUPPORT_COMMENT_SENDING":
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.workItemId]: {
            ...(state.comments[action.payload.workItemId] || defaultComments()),
            sending: action.payload.sending
          }
        }
      };

    case "SET_SUPPORT_CLOSING":
      return {
        ...state,
        closingWorkItemId: action.payload.workItemId
      };

    case "SET_SUPPORT_REOPENING":
      return {
        ...state,
        reopeningWorkItemId: action.payload.workItemId
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default supportReducer;
